import React, { ReactElement } from 'react';
import { Box, Typography } from '@mui/material';

interface AdminEmptyStateProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

export function AdminEmptyState({ icon, title, description }: AdminEmptyStateProps): ReactElement {
  return (
    <Box sx={{ 
      textAlign: 'center', 
      py: 6,
      bgcolor: 'background.paper',
      borderRadius: 2,
      border: '1px solid',
      borderColor: 'divider'
    }}>
      <Box sx={{ 
        fontSize: 64, 
        color: 'text.disabled', 
        mb: 2,
        filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))'
      }}>
        {icon}
      </Box>
      <Typography variant="h6" color="text.secondary" sx={{ mb: 1, fontWeight: 500 }}>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {description}
      </Typography>
    </Box>
  );
}


